import React, { useRef, useState } from 'react';
import { noop } from 'lodash';

import ElearningTestFeature from '@features/elearning-test';
import VideoFeature from '@features/video';
import {
  useElearningWpRemoteElearningAccept,
  useElearningWpRemoteFinish,
  useElearningWpRemoteSubmitTest,
  useElearningWpRemoteTestQuery
} from '@services/elearning-wp-remote';
import { useVismaConfiguration } from '@services/visitor-management';

import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import { useElearningWpRemoteFlow } from './shared/ewr-flow-context';

function ElearningWpRemoteTestSection() {
  const { data: questions, isLoading: isLoadingQuestions } =
    useElearningWpRemoteTestQuery();
  const submitMutation = useElearningWpRemoteSubmitTest();
  const finishMutation = useElearningWpRemoteFinish();
  return (
    <ElearningTestFeature
      questions={questions ?? []}
      isLoading={
        isLoadingQuestions ||
        submitMutation.isPending ||
        finishMutation.isPending
      }
      onSubmit={(testAnswers) => submitMutation.mutateAsync({ testAnswers })}
      onNext={() => finishMutation.mutateAsync().catch(noop)}
    />
  );
}

function ElearningWpRemoteVideoPage() {
  const { goBack } = useElearningWpRemoteFlow();
  const { configuration } = useVismaConfiguration();
  const hasTest =
    configuration?.elearningTestData?.compliance_test_has === 'yes';
  const [videoAccepted, setVideoAccepted] = useState(false);
  const acceptMutation = useElearningWpRemoteElearningAccept();
  const finishMutation = useElearningWpRemoteFinish();
  const testSectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const onElearningComplete = async (accepted: boolean) => {
    await acceptMutation.mutateAsync(accepted);
    if (!accepted) {
      return navigate(ROUTES.EWR_LOGOUT);
    }
    if (!hasTest) return void finishMutation.mutateAsync().catch(noop);

    setVideoAccepted(true);
    setTimeout(() => {
      testSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  };

  return (
    <VideoFeature
      onElearningComplete={onElearningComplete}
      isLoading={acceptMutation.isPending || finishMutation.isPending}
      onPreviousPage={goBack}
    >
      {videoAccepted && (
        <div ref={testSectionRef}>
          <ElearningWpRemoteTestSection />
        </div>
      )}
    </VideoFeature>
  );
}

export default ElearningWpRemoteVideoPage;
